// extracted by mini-css-extract-plugin
export default {"Container":"AttributeRowImage-module__Container__eLPKy","Image":"AttributeRowImage-module__Image__vEGa2"};